import { ModelBase } from "../../Core/Models/ModelBase";
import { OutstandingPayment } from "Custom/Models/DashboardModels/outstandingPayment";
import * as MobX from "mobx";

export class BuyModel extends ModelBase<BuyModel, BuyModelDTO> {
    @MobX.observable
    public token: string = "";

    @MobX.observable
    public name: string = "";

    @MobX.observable
    public propertyId: string = "";

    @MobX.observable
    public paymentSuccess: boolean | undefined;

    @MobX.observable
    public paymentResultAction: PaymentResultAction = PaymentResultAction.None;

    @MobX.observable
    public stripePayRequestId?: string;

    public fromDto = (model: BuyModelDTO) => {};
    public toDto = (model: BuyModel) => {};
}

export interface BuyModelDTO {
    name: string;
    propertyId: string;
    updatedStripePaymentRequests: UpdateStripePaymentRequestDTO[];
    paymentType: string;
    price: number;
    paymentSuccess: boolean;
    actionUrl: string;
    intentId: string;
    paymentMethodId: string;
    chosenOutstandingPayments: OutstandingPayment[];
    worldpaySession?: string;
    lang?: string;
    javaEnabled?: boolean;
    colorDepth?: number;
    screenHeight?: number;
    screenWidth?: number;
    timeZoneOffset?: number;
    stripePayRequestId?: string;
    collectionReference?: string;
    completedAction?: PaymentResultAction;
}

export interface UpdateStripePaymentRequestDTO {
    id: string;
    paidByIdentityUserId: string;
}

export enum PaymentResultAction {
    None = 0,
    DeviceDataCollection = 1,
    Challenge = 2,
}
